export default class TmdbService {
  _apiBase = "https://api.themoviedb.org/3/";
  _imageBase = "http://image.tmdb.org/t/p/";
  _apiKey = "api_key=251d3af594f2146364574f57013cdcf6";
  _language = "&language=en-EN";

  getResourse = async url => {
    const res = await fetch(`${this._apiBase}${url}`);
    if (!res.ok) {
      alert("Произошла ошибка");
    }
    return await res.json();
  };

  getPopularMovies = async page => {
    const res = await this.getResourse(
      `movie/popular?${this._apiKey}${this._language}&page=${page}`
    );
    return res.results;
  };
  getUpcomingMovies = async page => {
    const res = await this.getResourse(
      `movie/upcoming?${this._apiKey}${this._language}&page=${page}`
    );
    return res.results;
  };
  getPlayingMovies = async page => {
    const res = await this.getResourse(
      `movie/now_playing?${this._apiKey}${this._language}&page=${page}`
    );
    return res.results;
  };

  getDetails = async id => {
    const res = await this.getResourse(
      `movie/${id}?${this._apiKey}${this._language}`
    );
    return res;
  };

  getSimiliar = async id => {
    const res = await this.getResourse(
      `movie/${id}/similar?${this._apiKey}${this._language}&page=1`
    );
    return res.results;
  };

  searchMovie = async query => {
    if (!query) {
      return null;
    }
    const res = await this.getResourse(
      `search/movie?${this._apiKey}${this._language}&query=${query}&page=1&include_adult=false`
    );
    return res.results.slice(0, 10);
  };
}
